import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";
/**
 * WordPress dependencies
 */

import { __experimentalGradientPicker } from '@wordpress/components';
import { useSelect } from '@wordpress/data';

function GradientPickerWithGradients(props) {
  var gradients = useSelect(function (select) {
    return select('core/block-editor').getSettings().gradients;
  });
  return createElement(__experimentalGradientPicker, _extends({}, props, {
    gradients: gradients
  }));
}

export default function (props) {
  var ComponentToUse = props.gradients ? __experimentalGradientPicker : GradientPickerWithGradients;
  return createElement(ComponentToUse, props);
}